module.exports = __webpack_public_path__ + "assets/img/01.a537bb07.png";